import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import {
  getApiClient,
  initializeApiClient,
} from "../../../../../Services/apiService";

export const GetAllTE_OS_NatureOfSupport = createAsyncThunk(
  "dropdowns/GetAllTE_OS_NatureOfSupport",
  async (_, { rejectWithValue }) => {
    try {
      await initializeApiClient();
      const apiClient = await getApiClient();
      const response = await apiClient.post(
        "api/DropDowns/GetAllTE_OS_NatureOfSupport"
      );

      // Extract data from the response object
      const data = response.data.result; // Assuming response has a "data" field
      //console.log(data, "dataaaa");

      return data; // Return the extracted data
    } catch (error) {
      return rejectWithValue(error.message);
    }
  }
);

const DropDownNatureOfSupport = createSlice({
  name: "DropDownNatureOfSupport",
  initialState: {
    DropDownNatureOfSupport: [],
    loadingDropDownNatureOfSupport: false,
    errorDropDownNatureOfSupport: null,
  },
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(GetAllTE_OS_NatureOfSupport.pending, (state, action) => {
        state.loadingDropDownNatureOfSupport = true;
        state.DropDownDropDownNatureOfSupport = action.payload;
        state.errorDropDownNatureOfSupport = null;
      })
      .addCase(GetAllTE_OS_NatureOfSupport.fulfilled, (state, action) => {
        state.loadingDropDownNatureOfSupport = false;
        state.DropDownNatureOfSupport = action.payload; // Assuming payload has the desired data
      })
      .addCase(GetAllTE_OS_NatureOfSupport.rejected, (state, action) => {
        state.loadingDropDownNatureOfSupport = false;
        state.errorDropDownNatureOfSupport = action.payload;
      });
  },
});

export default DropDownNatureOfSupport.reducer;
